module.exports = __webpack_public_path__ + "img/solve.b0940413.png";